import React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { withLDConsumer } from 'launchdarkly-react-client-sdk';

import SubscribeToday from './pages/SubscribeToday';
import ReactivateToday from './pages/ReactivateToday';
import Reactivate from './pages/Reactivate';
import Upgrade from './pages/Upgrade';
import TrialUpgradeThanks from './pages/TrialUpgradeThanks';
import UpgradeThanks from './pages/UpgradeThanks';
import ReactivateThanks from './pages/ReactivateThanks';
import TrialUpgrade from './pages/TrialUpgrade';
import EmailPreferences from './pages/EmailPreferences';
import NotFoundError from './pages/NotFoundError';
import { addPathPrefix } from './helpers';

export const AppRoutes = ({ flags }) => {
  if (!flags || Object.keys(flags).length === 0) {
    return null;
  }

  return (
    <Router>
      <Switch>
        {flags.newReactivate !== false && (
          [
            <Route exact path={addPathPrefix('/reactivate-today', flags)} component={ReactivateToday} key="1" />,
            <Route exact path={addPathPrefix('/reactivate-my-membership', flags)} component={Reactivate} key="2" />,
            <Route exact path={addPathPrefix('/reactivate-thanks', flags)} component={ReactivateThanks} key="3" />,
          ]
        )}
        {flags.newUpgrade !== false && (
          [
            <Route exact path={addPathPrefix('/upgrade-confirmation', flags)} component={Upgrade} key="4" />,
            <Route exact path={addPathPrefix('/activate-membership', flags)} component={TrialUpgrade} key="5" />,
            <Route exact path={addPathPrefix('/upgrade-thanks', flags)} component={UpgradeThanks} key="6" />,
          ]
        )}
        <Route exact path="/subscribe-today" component={SubscribeToday} key="7" />
        <Route exact path={addPathPrefix('/trial-upgrade-thanks', flags)} component={TrialUpgradeThanks} key="8" />
        <Route exact path={addPathPrefix('/manage-email-preferences', flags)} component={EmailPreferences} key="9" />
        <Route exact path="/subscribe-today-thanks" component={ReactivateThanks} key="10" />
        <Route component={NotFoundError} key="10" />
      </Switch>
    </Router>
  );
};

export default withLDConsumer()(AppRoutes);
